import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, IConsultarFichaAlunoState } from './types';

export const INITIAL_STATE: IConsultarFichaAlunoState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IConsultarFichaAlunoState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_FICHA_ALUNO_REQUEST: {
				break;
			}
			case Types.CONSULTAR_FICHA_ALUNO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTAR_FICHA_ALUNO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTAR_FICHA_ALUNO_CLEAR: {
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
